<template>
  <vk-dialog :visible.sync="visible" @close="closeDialog" title="绑定推荐人" width="500px">
    <div class="bind-dialog-content">
      <span>推荐人信息：</span>
      <input
        v-model.trim="mobileNo"
        maxlength="11"
        placeholder="输入推荐人手机号"
        @focus="Onfocus"
        :class="{'mobileNo-warn': isMobilephoneWarnShow}"
      />
      <p class="mobileNo-test" v-if="isMobilephoneWarnShow">{{errorMsg}}</p>
    </div>
    <div class="bind-dialog-footer">
      <span
        class="btn-confirm"
        @click="sureBindMobilephone"
        vkshop-event-name="sureBindMobilephone"
        vkshop-event-type="click"
        :vkshop-event-param="'studentId=' + studentId + '&mobileNo=' + mobileNo"
      >确认绑定</span>
      <span
        class="btn-cancel"
        @click="cancelBindMobilephone"
        vkshop-event-name="cancelBindMobilephone"
        vkshop-event-type="click"
      >取消绑定</span>
    </div>
  </vk-dialog>
</template>

<script>
export default {
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    studentId: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      isMobilephoneWarnShow: false,
      errorMsg: "",
      mobileNo: ""
    };
  },
  watch: {
    visible: function(val) {
      this.mobileNo = "";
      this.isMobilephoneWarnShow = false;
    }
  },
  methods: {
    closeDialog() {
      this.$emit("update:visible", false);
    },
    Onfocus() {
      this.isMobilephoneWarnShow = false;
    },
    //确认绑定推荐人手机号
    sureBindMobilephone() {
      if (!this.mobileNo) {
        this.isMobilephoneWarnShow = true;
        this.errorMsg = "手机号不能为空！";
        return;
      }
      let regs = /^1([3-9][\d])\d{8}$/;
      if (!regs.test(this.mobileNo)) {
        this.isMobilephoneWarnShow = true;
        this.errorMsg = "请输入正确的手机号！";
        return;
      }
      this.axios({
        method: "post",
        url: "/mall/api/userCenter/rRelationship/bind",
        data: {
          studentId: this.studentId,
          mobileNo: this.mobileNo
        }
      }).then(response => {
        if (response.data.code == 200) {
          this.$emit("mobilePhoneNo", response.data.data);
          this.closeDialog();
        } else {
          this.isMobilephoneWarnShow = true;
          this.errorMsg = response.data.msg;
        }
      });
    },
    //取消绑定
    cancelBindMobilephone() {
      this.closeDialog();
    }
  }
};
</script>

<style lang="less" scoped>
.bind-dialog-content {
  padding: 34px 52px 56px;
  text-align: center;
  span {
    font-size: 14px;
  }
  input {
    display: inline-block;
    width: 230px;
    height: 40px;
    border: 1px solid #ccc;
    padding-left: 10px;
  }
  .mobileNo-test {
    color: #f85415;
    font-size: 14px;
    text-align: left;
    padding-left: 105px;
  }
  .mobileNo-warn {
    border-color: #f85415;
  }
}
.bind-dialog-footer {
  text-align: center;
  span {
    cursor: pointer;
    display: inline-block;
    width: 100px;
    height: 36px;
    line-height: 36px;
    margin: 0 20px 36px 20px;
    text-align: center;
    font-size: 14px;
    border-radius: 5px;
  }
  .btn-confirm {
    box-shadow: 0px 0px 10px 0px rgba(255, 103, 26, 0.2),
      0px 5px 10px 0px rgba(255, 103, 26, 0.4);
    background-color: #f85415;
    color: #fff;
  }
  .btn-cancel {
    background-color: #cccccc;
    color: #000;
  }
}
</style>
